import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MarkerDataService } from 'src/app/shared/service/makerservice/markerDataService';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-details-project',
  standalone: false,
  templateUrl: './details-project.component.html',
  styleUrl: './details-project.component.scss'
})
export class DetailsProjectComponent {

  selectedProject: any = null;

  projects: any[] = [];
  displayedProjects: any[] = [];

  pageSize = 6;
  currentIndex = 0;
  projetDetailsIems: any = [];
  constructor(
    private router: Router,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private location: Location,
    private route: ActivatedRoute

  ) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0); // ← ⬆️ Remonte en haut à chaque navigation
      }
    });
  }
  loading: boolean = true;

  ngOnInit() {
    // Projet sélectionné
    this.selectedProject = this.localStorage.getAccueil();
    console.log('Projet sélectionné', this.selectedProject);

    // Charger les autres projets


    this.route.paramMap.subscribe(params => {
      const reference = params.get('reference');
      console.log(reference);

      this.getDetailsProjet(reference);

    });

    this.getProjects();

  }


  getDetailsProjet(item: any) {

    this.paramService.getDetailProjetAc(item).subscribe(
      (response: any) => {

        console.log("la réponse du webservice", response);

        this.projetDetailsIems = response.data;


      },
      (error: any) => {
        console.log("une erreur est survenu", error);

      }
    )

  }

  goToDetailsProjet(item: any) {
    this.router.navigate(['/projet', item.reference]).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  getProjects() {
    this.loading = true;
    this.paramService.getPdc().subscribe(
      (response: any) => {
        this.projects = response.data || [];
        this.loadMore();
        this.loading = false;

      },
      (error) => {
        console.error('Erreur chargement projets', error);
      }
    );
  }

  loadMore() {
    const nextItems = this.projects.slice(
      this.currentIndex,
      this.currentIndex + this.pageSize
    );

    this.displayedProjects = [
      ...this.displayedProjects,
      ...nextItems
    ];

    this.currentIndex += this.pageSize;
  }



  goBack(): void {
    this.location.back(); // Retourne à la page précédente
    // Ou utilisez votre logique de navigation personnalisée
    // this.router.navigate(['/votre-route']);
  }
  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/default.jpg';
  }
}
